import { render, staticRenderFns } from "./ClientScreenInfo.vue?vue&type=template&id=775f6ab0&scoped=true"
import script from "./ClientScreenInfo.vue?vue&type=script&lang=ts"
export * from "./ClientScreenInfo.vue?vue&type=script&lang=ts"
import style0 from "./ClientScreenInfo.vue?vue&type=style&index=0&id=775f6ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775f6ab0",
  null
  
)

export default component.exports